import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private readonly toastr = inject(ToastrService);
    private readonly translateService = inject(TranslateService);


    public success(message: string, title?: string, params?: Object, toastrSettings?: Object): void {
        message = this.translateService.instant(message, params);
        this.toastr.success(message, title, toastrSettings);
    }

    public info(message: string, title?: string): void {
        message = this.translateService.instant(message);
        this.toastr.info(message, title);
    }

    public warning(message: string, title?: string): void {
        message = this.translateService.instant(message);
        this.toastr.warning(message, title);
    }

    public error(message: string, title?: string): void {
        message = this.translateService.instant(message);
        this.toastr.error(message, title);
    }
}
